var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgOpSymbolikuvitus96120(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 128,
    height: 128,
    viewBox: "0 0 128 128",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "2021_OP_symbolikuvitus_96_120 2",
    clipPath: "url(#clip0_8796_5249)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "taustavalko"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M128 0H0V128H128V0Z",
    fill: "white"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Layer 1"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M85.3081 67.7725C85.3081 71.2392 75.6847 81.9904 64.0461 81.9904C52.4074 81.9904 42.7378 70.2777 42.7378 67.7725C42.7378 48.84 42.7378 30 63.9999 30C85.2619 30 85.3081 48.84 85.3081 67.7725Z",
    stroke: "#6E6E6E",
    strokeWidth: 1.25,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Vector_3"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M41 98.6117C41 85.5679 51.2982 81.8701 64 81.8701C76.7018 81.8701 87 85.5679 87 98.5932",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M41 98.6117C41 85.5679 51.2982 81.8701 64 81.8701C76.7018 81.8701 87 85.5679 87 98.5932",
    stroke: "#6E6E6E",
    strokeWidth: 1.25,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Vector_4",
    d: "M58.5737 76.4531V82.3048C58.5737 85.9286 61.421 87.5371 64.0002 87.5371C66.5794 87.5371 69.4266 85.9286 69.4266 82.3048V76.4531H58.5737Z",
    fill: "white",
    stroke: "#6E6E6E",
    strokeWidth: 1.25,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Vector_5"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M79.5859 64.0839C81.8046 64.4075 82.5257 62.6511 83.1635 60.5064C83.9493 57.8902 82.9694 56.3834 80.7507 56.0598",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M79.5859 64.0839C81.8046 64.4075 82.5257 62.6511 83.1635 60.5064C83.9493 57.8902 82.9694 56.3834 80.7507 56.0598",
    stroke: "#6E6E6E",
    strokeWidth: 1.25,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Vector_6"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M48.4141 64.0839C46.1954 64.4075 45.4744 62.6511 44.8365 60.5064C44.0507 57.8902 45.0306 56.3834 47.2493 56.0598",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M48.4141 64.0839C46.1954 64.4075 45.4744 62.6511 44.8365 60.5064C44.0507 57.8902 45.0306 56.3834 47.2493 56.0598",
    stroke: "#6E6E6E",
    strokeWidth: 1.25,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Vector_7"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M48.0442 64.7312C48.8392 69.187 50.2259 70.093 52.1394 72.5242C55.264 76.4808 60.4132 79.4668 64 79.4668C67.5868 79.4668 73.2444 76.4901 76.0177 72.5242C77.9056 70.0078 79.1726 67.0811 79.7154 63.9824",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M48.0442 64.7312C48.8392 69.187 50.2259 70.093 52.1394 72.5242C55.264 76.4808 60.4132 79.4668 64 79.4668C67.5868 79.4668 73.2444 76.4901 76.0177 72.5242C77.9056 70.0078 79.1726 67.0811 79.7154 63.9824",
    stroke: "#6E6E6E",
    strokeWidth: 1.25,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Vector_8",
    d: "M80.4641 56.217C80.6355 54.8371 80.7189 53.4476 80.7137 52.0571C80.7137 51.8537 80.7137 51.6596 80.7137 51.4562C79.438 49.7922 77.9404 46.5751 76.0915 41.9067C76.0915 41.9067 67.2631 51.6318 47.3323 52.7227C47.3358 53.992 47.4067 55.2603 47.5449 56.5221",
    stroke: "#6E6E6E",
    strokeWidth: 1.25,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_9",
    d: "M63.6764 59.1106L62.8906 65.7111H65.1093",
    stroke: "#6E6E6E",
    strokeWidth: 1.25,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_10",
    d: "M66.0891 68.8726C65.9488 69.3167 65.6707 69.7046 65.295 69.98C64.9193 70.2553 64.4657 70.4037 63.9999 70.4037C63.5341 70.4037 63.0804 70.2553 62.7047 69.98C62.3291 69.7046 62.0509 69.3167 61.9106 68.8726",
    stroke: "#6E6E6E",
    strokeWidth: 1.25,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_11",
    d: "M53.6926 58.0659C53.6926 58.4882 53.8179 58.9011 54.0525 59.2523C54.2872 59.6034 54.6207 59.8771 55.0109 60.0388C55.4011 60.2004 55.8304 60.2427 56.2447 60.1603C56.6589 60.0779 57.0394 59.8745 57.3381 59.5759C57.6367 59.2772 57.8401 58.8967 57.9225 58.4825C58.0049 58.0682 57.9626 57.6389 57.801 57.2487C57.6394 56.8585 57.3656 56.525 57.0145 56.2903C56.6633 56.0557 56.2504 55.9304 55.8281 55.9304C55.2617 55.9304 54.7186 56.1554 54.3181 56.5559C53.9176 56.9564 53.6926 57.4995 53.6926 58.0659Z",
    fill: "#6E6E6E"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_12",
    d: "M74.3167 58.0659C74.3185 58.4904 74.1943 58.906 73.9598 59.2599C73.7252 59.6138 73.3909 59.8901 72.9992 60.0539C72.6075 60.2176 72.1759 60.2614 71.7593 60.1797C71.3427 60.098 70.9597 59.8945 70.6588 59.5949C70.3579 59.2953 70.1527 58.9132 70.0692 58.4969C69.9857 58.0807 70.0277 57.649 70.1897 57.2565C70.3518 56.8641 70.6266 56.5286 70.9795 56.2925C71.3324 56.0564 71.7474 55.9304 72.172 55.9304C72.7392 55.9304 73.2833 56.1551 73.6853 56.5553C74.0872 56.9555 74.3143 57.4987 74.3167 58.0659Z",
    fill: "#6E6E6E"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_8796_5249"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 128,
    height: 128,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgOpSymbolikuvitus96120);
export default __webpack_public_path__ + "static/media/OP_symbolikuvitus_96_120.1ecd42df4e9c0b2c43e30344b7686aeb.svg";
export { ForwardRef as ReactComponent };